import classNames from 'classnames';

/**
 * Gets the common className for modals with sticky footer
 * @param additionalClasses - Optional additional classes to append
 * @returns The className string
 */
export const getStickyFooterModalClassName = (additionalClasses?: string): string => {
  return classNames('md:max-h-[90vh]', additionalClasses);
};

/**
 * Gets the common modalBodyClassName for modals with sticky footer
 * @param additionalClasses - Optional additional classes to append
 * @returns The className string
 */
export const getStickyFooterModalBodyClassName = (additionalClasses?: string): string => {
  return classNames('h-full min-h-0 md:max-h-[90vh]', additionalClasses);
};
